export class EmpTeamRequest {
    employeeCode: string;
    teamCode: string;

    constructor(employeeCode: string, teamCode: string) {
        this.employeeCode = employeeCode;
        this.teamCode = teamCode;
    }
}